<script setup lang="ts">

</script>

<template>
  <div class="layout">
    <div class="layout-img">
    </div>
    <main class="layout-main">
      <slot/>
    </main>
    <section class="layout-bottom">
    </section>
    <snackbar/>
  </div>
</template>

<style scoped lang="scss">
@use 'assets/css/tokens/colors' as *;
@use 'assets/css/tokens/typography' as *;
.layout-img{
  height: 30vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}
.layout-desktop-logo{
  height: 24px;
  margin-top: 1rem;
}
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  background-color: $color-white;
}


.layout-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  padding: 1.875rem 0.5rem 1.875rem 0.5rem;
}

.layout-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  padding: 1.125rem .5rem;
  border-top: 1px solid $color-border;
  justify-content: space-around;
}

</style>